/* eslint-disable jsx-a11y/alt-text */
/* Original name @uswitch/trustyle.hero */

import * as React from 'react'
import { useThemeUI } from 'theme-ui'
import { path } from '@uswitch/ev-utils/lib/obj'
import { Palette } from '../palette'

const makeStyles = variant => element =>
  `elements.hero${variant ? `.variants.${variant}` : ''}${element ? `.${element}` : ''}`

const DefaultContainer = ({ children }) => (
  <div sx={{ maxWidth: 1024, margin: '0 auto', paddingX: 10 }}>{children}</div>
)

const Hero = ({
  breadcrumbs,
  container: Container = DefaultContainer,
  fgImage,
  fgImageType = 'background',
  fgImagePosition,
  fgImageOnMobile = false,
  fgImageOnTablet = false,
  customBgColor = '',
  children,
  variant,
  bottomImageOverflow = '-33%',
  className,
}) => {
  const { theme } = useThemeUI()
  const styles = makeStyles(variant)
  const breadcrumbVariant = path(styles('breadcrumbs.variant').split('.'), theme)
  const breadcrumbWithVariant =
    breadcrumbs && React.cloneElement(breadcrumbs, { variant: breadcrumbVariant })

  return (
    <div>
      <Palette
        as='div'
        sx={{ overflow: 'hidden', variant: styles('wrapper') }}
        px={{ backgroundColor: 'backgroundColor' }}
      >
        <div
          sx={{
            position: 'relative',
            overflow: 'hidden',
            background: customBgColor || undefined,
          }}
          className={className}
        >
          <Container sx={{ variant: styles('container') }}>
            <If condition={breadcrumbs}>
              <div sx={{ paddingTop: 'sm', variant: styles('breadcrumbs') }}>
                {breadcrumbWithVariant}
              </div>
            </If>
            <div
              sx={{
                position: 'relative',
                display: 'block',
                flexDirection: 'row-reverse',
              }}
            >
              <div
                sx={{
                  position: 'absolute',
                  left: [0, '45%'],
                  right: 0,
                  top: 0,
                  bottom: 0,
                  display: [
                    fgImageOnMobile ? 'block' : 'none',
                    fgImageOnTablet ? 'block' : 'none',
                    'block',
                  ],
                  ...(fgImage && fgImageType === 'background'
                    ? {
                        backgroundImage: `url(${fgImage})`,
                        backgroundRepeat: 'no-repeat',
                        ...fgImagePosition,
                      }
                    : undefined),
                  variant: styles('image'),
                }}
              >
                <If condition={fgImage && fgImageType === 'img'}>
                  <img
                    sx={{
                      maxWidth: '100%',
                      position: 'absolute',
                      ...fgImagePosition,
                    }}
                    src={fgImage}
                    role='presentation'
                  />
                </If>
              </div>
              <div
                sx={{
                  position: 'relative',
                  paddingTop: ['sm', 'xxl'],
                  paddingBottom: ['sm', 'xxl'],
                  variant: styles('content'),
                }}
              >
                {children}
              </div>
            </div>
          </Container>
        </div>
      </Palette>
      <If condition={fgImage}>
        <img
          sx={{
            maxWidth: '100%',
            position: 'relative',
            display: 'none',
            marginTop: `-${bottomImageOverflow}`,
            marginLeft: 'auto',
            marginRight: 'auto',
            variant: styles('bottomImage'),
          }}
          src={fgImage}
          role='presentation'
        />
      </If>
    </div>
  )
}
export default Hero
